import PropTypes from 'prop-types'
import React from 'react'

const PermissionsIcon = ({
   className,
   color,
   width,
   height,
   strokeWidth
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         fill={color}>
         <path
            d="M16.536,13.41a1,1,0,0,0-1.414,1.414l2.82,2.82-1.317,1.317-2.82-2.82a1,1,0,1,0-1.414,1.414l2.557,2.558a5.043,5.043,0,0,1-2.281.377,3.565,3.565,0,0,1-.8,1.923,7.091,7.091,0,0,0,1.135.1,6.983,6.983,0,0,0,4.95-2.047l2.108-2.136a1,1,0,0,0-.006-1.411Z"
         />
         <path
            d="M1.821,12.856a3.591,3.591,0,0,1,1.023-.7A6.052,6.052,0,0,1,9.082,3.09l.433-.433A9.188,9.188,0,0,1,10.9,1.517,8.068,8.068,0,0,0,1.321,13.5,3.628,3.628,0,0,1,1.821,12.856Z"
         />
         <rect
            x="0.786"
            y="15.158"
            width="11.894"
            height="5.222"
            rx="2.611"
            ry="2.611"
            transform="translate(14.537 0.443) rotate(45)"
            fill={color}
         />
         <path
            d="M21.636,3.364a8.071,8.071,0,0,0-11.414,0L5.585,8l.708.707a3.125,3.125,0,0,0,4.414,0L12.5,6.916l8.424,8.576.714-.714a8.071,8.071,0,0,0,0-11.414Z"
            fill={color}
         />
      </g>
   </svg>
)

PermissionsIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

PermissionsIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1',
   width: '24px'
}

export default React.memo(PermissionsIcon)
